import { chameleonSvg } from '../../Svg';
import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonDataTableHeaderCellV2 } from './DataTableHeaderCellV2.definition';
import '@getgo/chameleon-typography/register/default';
provideChameleonDesignSystem().register(chameleonDataTableHeaderCellV2(), chameleonSvg());
